export default "__VITE_ASSET__CddoYGr6__"